// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__21_fX","selects":"Documents_selects__1X70J"};